import React, { useEffect, useState } from "react"; // import { Button, TextField } from "@mui/material";

import { Autocomplete, Button, TextField } from "@mui/material";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getStudyById,
  patchStudy,
  postStudy,
} from "../../../Services/CaseStudy";

import axios from "axios";
import { baseUrl } from "../../../Config/baseUrl";

const AddCaseStudy = () => {
  const navigate = useNavigate();
  const { state: caseStudyId } = useLocation();
  const { type } = useParams();

  const [pages, setPages] = useState([]);
  const [pageId, setPageId] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    image: null,
    project_snapshot: "",
    url: "",
    country: "",
    industry_vertical: "",
    business_insights: "",
    solution_provided: "",
    platform: "",
  });

  // Get single data for update
  //   useQuery(
  //     ["case-study-by-id", caseStudyId],
  //     () => getStudyById(caseStudyId),
  //     {
  //       enabled: type === "update",
  //       onSuccess: (res) => {
  //         // const data = res?.data?.data;
  //         //   const data = res?.data?.data || res?.data;
  //   const data = res?.data?.data || res?.data;

  //         setFormData({
  //           title: data?.title || "",
  //           image: null,
  //           project_snapshot: data?.project_snapshot || "",
  //           url: data?.url || "",
  //           country: data?.country || "",
  //           industry_vertical: data?.industry_vertical || "",
  //           business_insights: data?.business_insights || "",
  //           solution_provided: data?.solution_provided || "",
  //           platform: data?.platform || "",
  //         });
  //       },
  //     }
  //   );
  useEffect(() => {
    axios
      .get(`${baseUrl}/blog/frontend-page-id-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        console.log("PAGE API RESPONSE", res.data);
        setPages(res.data.data || []);
      })
      .catch((error) => {
        console.error("Page API Error:", error);
        toast.error("Failed to load pages");
      });
  }, []);
  useQuery(
    ["case-study-by-id", caseStudyId],
    () =>
      getStudyById({
        case_study_id: caseStudyId,
      }),
    {
      enabled: type === "update" && !!caseStudyId,

      onSuccess: (res) => {
        console.log("UPDATE RESPONSE", res);

        const data = res?.data?.data || res?.data;

        setFormData({
          title: data?.title || "",
          image: null,
          project_snapshot: data?.project_snapshot || "",
          url: data?.url || "",
          country: data?.country || "",
          industry_vertical: data?.industry_vertical || "",
          business_insights: data?.business_insights || "",
          solution_provided: data?.solution_provided || "",
          platform: data?.platform || "",
        });
        setPageId(data?.page_id || "");
      },
    },
  );

  const { mutate: addCaseStudy } = useMutation(postStudy, {
    onSuccess: () => {
      toast.success("Case Study Added Successfully");
      navigate("/case-study");
    },
  });

  const { mutate: updateCaseStudy } = useMutation(patchStudy, {
    onSuccess: () => {
      toast.success("Case Study Updated Successfully");
      navigate("/case-study");
    },
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImage = (e) => {
    setFormData({
      ...formData,
      image: e.target.files[0],
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();

    data.append("title", formData.title);
    data.append("project_snapshot", formData.project_snapshot);
    data.append("url", formData.url);
    data.append("country", formData.country);
    data.append("industry_vertical", formData.industry_vertical);
    data.append("business_insights", formData.business_insights);
    data.append("solution_provided", formData.solution_provided);
    data.append("platform", formData.platform);

    data.append("page_id", pageId);

    if (formData.image) {
      data.append("image", formData.image);
    }

    // Update
    if (type === "update") {
      data.append("case_study_id", caseStudyId);

      updateCaseStudy(data);
    }
    // Add
    else {
      if (!formData.image) {
        return toast.error("Image is required");
      }

      addCaseStudy(data);
    }
  };

  return (
    <div className="p-2">
      <h1 className="text-3xl text-center text-blue-900 underline mb-2">
        {type === "update" ? "Update Case Study" : "Add Case Study"}
      </h1>

      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 md:grid-cols-2 gap-4"
      >
        <TextField
          label="Title"
          name="title"
          value={formData.title}
          onChange={handleChange}
        />

        <TextField
          label="Project Snapshot"
          name="project_snapshot"
          value={formData.project_snapshot}
          onChange={handleChange}
        />

        <TextField
          label="URL"
          name="url"
          value={formData.url}
          onChange={handleChange}
        />

        <TextField
          label="Country"
          name="country"
          value={formData.country}
          onChange={handleChange}
        />

        <TextField
          label="Industry Vertical"
          name="industry_vertical"
          value={formData.industry_vertical}
          onChange={handleChange}
        />

        <TextField
          label="Business Insights"
          name="business_insights"
          value={formData.business_insights}
          onChange={handleChange}
        />

        <TextField
          label="Solution Provided"
          name="solution_provided"
          value={formData.solution_provided}
          onChange={handleChange}
        />

        <TextField
          label="Platform"
          name="platform"
          value={formData.platform}
          onChange={handleChange}
        />

        <Autocomplete
          options={pages}
          getOptionLabel={(option) => option.name || ""}
          value={pages.find((page) => page.id === pageId) || null}
          onChange={(event, newValue) => {
            setPageId(newValue ? newValue.id : "");
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField {...params} label="Select Page" />
          )}
        />
        <input type="file" accept="image/*" onChange={handleImage} />

        <div className="md:col-span-2">
          <Button type="submit" variant="contained">
            {type === "update" ? "Update" : "Save"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddCaseStudy;
